<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { computed } from 'vue';
import AuthenticatedMediaImage from './AuthenticatedMediaImage.vue';

const props = defineProps({
  media: { type: Array, default: () => [] },
});

const images = computed(() =>
  props.media.filter(item => item.kind === 'image' && item.thumbnail_url)
);
const visibleImages = computed(() => images.value.slice(0, 4));
const remaining = computed(() => Math.max(images.value.length - 4, 0));
</script>

<template>
  <div
    v-show="visibleImages.length"
    class="mt-4 grid overflow-hidden rounded-lg bg-n-alpha-2"
    :class="visibleImages.length === 1 ? 'grid-cols-1' : 'grid-cols-2'"
    data-post-media-grid="tg_publication_post_media_grid"
  >
    <div
      v-for="(item, index) in visibleImages"
      :key="item.id"
      class="relative min-h-28 overflow-hidden border border-n-weak bg-n-alpha-2 sm:min-h-36"
      :class="{ 'col-span-2': visibleImages.length === 3 && index === 0 }"
    >
      <AuthenticatedMediaImage
        :src="item.thumbnail_url"
        :alt="item.filename || 'Изображение публикации'"
        loading="lazy"
        class="absolute inset-0 size-full"
        image-class="size-full object-cover"
        placeholder-class="flex size-full flex-col items-center justify-center gap-2 p-3 text-center text-xs text-n-slate-10"
      />
      <div
        v-if="remaining && index === visibleImages.length - 1"
        class="absolute inset-0 flex items-center justify-center bg-n-alpha-black2 text-xl font-medium text-white"
      >
        +{{ remaining }}
      </div>
    </div>
  </div>
</template>
